__turbopack_context__.v({
  "Banner2Rel": "footer1-module__KXALkG__Banner2Rel",
  "BannerMAbsImgAll": "footer1-module__KXALkG__BannerMAbsImgAll",
  "BannerMAbsImgAll2": "footer1-module__KXALkG__BannerMAbsImgAll2",
  "Button3BoxImgAbs4": "footer1-module__KXALkG__Button3BoxImgAbs4",
  "Footer1": "footer1-module__KXALkG__Footer1",
  "FooterBgTxtBox": "footer1-module__KXALkG__FooterBgTxtBox",
  "FooterSec": "footer1-module__KXALkG__FooterSec",
  "LogoNone2": "footer1-module__KXALkG__LogoNone2",
  "OrderBgh3": "footer1-module__KXALkG__OrderBgh3",
  "SliderTopTxtAbsImg2": "footer1-module__KXALkG__SliderTopTxtAbsImg2",
  "SocialIconBox": "footer1-module__KXALkG__SocialIconBox",
});
